import { useEffect } from 'react';
import { CircularProgress, Box } from '@mui/material';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { routes } from '@frontend/router/routes';
import { useSnackBar } from '@frontend/features/common/components/SnackBarContext';
import { SEARCH_NAVIGATION } from '../searchNavigation';
import { useSearchAvailability } from '../useSearchAvailability';

export function SearchAvailabilityGuard() {
  const { pathname } = useLocation();
  const availability = useSearchAvailability();
  // React Router matches these routes case-insensitively and accepts a trailing slash.
  const normalizedPath = pathname.replace(/\/+$/, '').toLowerCase();
  const entry = SEARCH_NAVIGATION.find((item) => item.route === normalizedPath);
  const status = entry?.vertical ? availability(entry.vertical) : 'available';
  const { addToast } = useSnackBar();
  const { t } = useTranslation();
  useEffect(() => {
    if (status === 'unavailable') addToast({ message: t('common.nav.serviceUnavailable'), color: 'warning' });
  }, [status, addToast, t]);
  if (status === 'loading') return (
    <Box display="flex" justifyContent="center" p={4}>
      <CircularProgress />
    </Box>
  );
  if (status === 'unavailable') return <Navigate to={routes.home} replace />;
  return <Outlet />;
}
